<app-classify-form-wrapper
  #formWrapper
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
></app-classify-form-wrapper>
